import axios from "axios";

const baseUrl = process.env.REACT_APP_ORDERS_SERVICE_BASE_URL;

interface DateRangeParams {
  startDate: string;
  endDate: string;
  filterType: 'daily' | 'weekly' | 'monthly' | 'custom';
}

export const setDashboardNumbers = async (dateRange?: DateRangeParams) => {
  let response;
  const params = dateRange ? {
    start_date: dateRange.startDate,
    end_date: dateRange.endDate,
    filter_type: dateRange.filterType
  } : {};

  await axios
    .get(`${baseUrl}/api/v1/admin/get-rides-count`, {
      headers: {
        "Cache-Control": "no-cache",
        "Content-Type": "application/json",
      },
      params
    })
    .then((res) => {
      console.log("data", res.data.data);
      response = {
        current: res.data.data.current,
        timeSeries: res.data.data.timeSeries,
        dateRange: dateRange || {
          startDate: new Date().toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0],
          filterType: 'daily'
        }
      };
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {
        current: {},
        timeSeries: {},
        dateRange: dateRange || {
          startDate: new Date().toISOString().split('T')[0],
          endDate: new Date().toISOString().split('T')[0],
          filterType: 'daily'
        }
      };
    });

  return response;
};
